import { makeStyles } from '@material-ui/core';

import { TOP_BAR_HEIGHT } from '../TopBar/constants';
import { DRAWER_WIDTH, RAIL_WIDTH } from './constants';

export const useStyles = makeStyles(theme => ({
  staffChip: { backgroundColor: '#f44336', color: 'white' },
  menuSection: {
    lineHeight: '35px',
  },
  menuSectionHeader: { cursor: 'pointer' },
  flyoutSectionHeader: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  flyoutSectionTitle: {
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
  flyoutItemList: {
    '& .MuiButtonBase-root': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  subFlyoutPaper: {
    clipPath: 'inset(-24px -24px -24px 0px)',
  },
  railHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    height: 35,
    position: 'relative',
  },
  railFavoritesDivider: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    margin: 0,
  },
  favoritesHeader: {
    lineHeight: '35px',
    fontWeight: 600,
  },
  favoritesStar: { color: '#f5a623', marginRight: 8, fontSize: 18 },
  mobileDrawer: { width: 300 },
  desktopDrawer: {
    height: `calc(100% - ${TOP_BAR_HEIGHT}px)`,
    top: TOP_BAR_HEIGHT,
    width: props => (props.isNavCollapsed ? RAIL_WIDTH : DRAWER_WIDTH),
    transition: theme.transitions.create('width', { duration: theme.transitions.duration.short }),
  },
  avatar: { height: 64, width: 64 },
  railSectionAvatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 35,
    height: 35,
    borderRadius: theme.shape.borderRadius,
    fontSize: theme.typography.pxToRem(22),
    fontWeight: theme.typography.fontWeightBold,
    textTransform: 'uppercase',
  },
  railScrollWrapper: {
    '& .ps__rail-y': {
      width: 6,
    },
    '& .ps__thumb-y': {
      width: 3,
      right: 1,
    },
    '& .ps__rail-y:hover > .ps__thumb-y, & .ps__rail-y.ps--clicking .ps__thumb-y': {
      width: 3,
    },
  },
}));
